export const copyToClipboard = (value: string | undefined | null) => {
  return navigator.clipboard.writeText(value || '').catch(() => {});
};
